<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE  ref="userChildUpdate"  @submit="userSubmit" :updateData="userUpdateData"></UPDATE>
    <UPDATE  ref="usersChildUpdate"  @submit="usersSubmit" :updateData="usersUpdateData" @uploadFile="uploadFile"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Qs from 'qs'
  import Url from "@/views/crs36/util/url";
  let activeStatus = {"0":"未激活","1":"已激活"}
  let status = {"1":"待审批","2":"进行中","3":"未开始","4":"已结束"}  //1:待审批，2:进行中 3:未开始 4:已结束
  let levelType = {"MIN":"迷你","STD":"标准","PLA":"铂金","ZER":"巴菲特","MIN2":"迷你2","STD2":"标准2","PLA2":"铂金2"};  //1:待审批，2:进行中 3:未开始 4:已结束
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      uploadFile(col,result){
        col.data = JSON.stringify(result);
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          row.activeTime = [row.startTime,row.endTime];
          row.openTime = [row.openStartTime,row.openEndTime];
          row.activeStatus = row.activeStatus.split(",");
          row.levelType = row.levelType.split(",");
          this.$refs.childUpdate.open(row);
        }else if (clickName == "copy"){
          row.activeTime = [row.startTime,row.endTime];
          row.openTime = [row.openStartTime,row.openEndTime];
          row.activeStatus = row.activeStatus.split(",");
          row.levelType = row.levelType.split(",");
          row.id = null;
          row.status = 1;
          this.$refs.childUpdate.open(row);
        }else if("delete" == clickName){
          //审核或启动等操作
          this.dataChanage(Url.experience.list.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }else if("apply" == clickName){
          //审核或启动等操作
          this.dataChanage(Url.experience.list.apply,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }else if(clickName == "addUser"){
          this.$refs.userChildUpdate.open(row);
        }else if(clickName == "addUsers"){
          this.$refs.usersChildUpdate.open(row);
        }else if(clickName == "user"){
          this.$router.push({path: `/crs36/experience/user?label=CRS36&taskId=${row.taskId}`})
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        model.startTime = model.activeTime[0];
        model.endTime = model.activeTime[1];
        model.openStartTime = model.openTime[0];
        model.openEndTime = model.openTime[1];
        model.activeStatus = model.activeStatus.join(",");
        model.levelType = model.levelType.join(",");
        //根据是否包含id更新还是添加
        this.dataChanage(Url.experience.list.edit,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
              this.$message.error(res.message);
          }
        })
      },
      userSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.experience.user.edit,model,res => {
          //this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.userChildUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      usersSubmit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.experience.user.uploadUser,model,res => {
          //this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.userChildUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
              { title: 'id', field: 'id',hidden:true},
              { title: '活动id', field: 'taskId',required:true,type:7},
              { title: '活动名称', field: 'taskName',required:true},
              { title: '重置金额', field: 'resetAmount',required:true},
              { title: '活动时间', field: 'activeTime',type:9,required:true,data:[]},
              { title: '开户时间', field: 'openTime',type:9,required:true,data:[]},
              { title: '活动状态', field: 'status',data:1,hidden:true},
              { title: '激活状态', field: 'activeStatus',type:4,optionList:activeStatus,data:[],required:true},
              { title: '账号级别', field: 'levelType',type:4,optionList:levelType,data:[],required:true},
              ]
        },
        userUpdateData:{
          cols:[
            { title: '手机区号', field: 'mobilePhonePrefix',data:"84",hidden:true},
            { title: '手机号', field: 'mobilePhone',required:true},
            { title: '真实账号', field: 'realAccount',required:true},
            { title: '模拟账号', field: 'demoAccount',required:true},
            { title: '活动id', field: 'taskId', hidden:true},
            { title: '活动名称', field: 'taskName', hidden:true},
            { title: '开始时间', field: 'startTime', hidden:true},
            { title: '结束时间', field: 'endTime', hidden:true},
            { title: '报名方式', field: 'type',data:2, hidden:true},
            { title: '活动状态', field: 'status',data:2, hidden:true},
          ]
        },
        usersUpdateData:{
          cols:[
            { title: '手机区号', field: 'mobilePhonePrefix',data:"84",hidden:true},
            { title: '上传用户', field: 'mobilePhone',type:11,action:Url.experience.user.uploadTemplate,downUrl:"https://static.chwenda.com/source/material/trex/trialBonus.xlsx"},
            { title: '活动id', field: 'taskId', hidden:true},
            { title: '活动名称', field: 'taskName', hidden:true},
            { title: '开始时间', field: 'startTime', hidden:true},
            { title: '结束时间', field: 'endTime', hidden:true},
            { title: '报名方式', field: 'type',data:2, hidden:true},
            { title: '活动状态', field: 'status',data:2, hidden:true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '活动id', field: 'taskId'},
            { title: '开始时间', field: 'startTime',type:5},
            { title: '结束时间', field: 'endTime',type:5},
            {click:"查询",auth:"crs36:experience:find"},
            {click:"新增",auth:"crs36:experience:add"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.experience.list.qurey, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [
              { title: '活动id', field: 'taskId'},
              { title: '活动名称', field: 'taskName'},
              { title: '开始时间', field: 'startTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '结束时间', field: 'endTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '开户开始时间', field: 'openStartTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '开户结束时间', field: 'openEndTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '活动状态', field: 'status',render:(data,full)=>{
                return status[data];
                }},
              { title: '激活状态', field: 'activeStatus',render:(data,full)=>{
                  let split = data.split(",");
                  let arr = [];
                  for (const i in split) {
                    arr.push(activeStatus[split[i]]);
                  }
                  return arr.join(",");
                }},
              { title: '账号级别', field: 'levelType',render:(data,full)=>{
                  let split = data.split(",");
                  let arr = [];
                  for (const i in split) {
                    arr.push(levelType[split[i]]);
                  }
                  return arr.join(",");
                }},
              { title: '参与用户', field: 'userCount',h5Click:"user",render:(data,full)=>{
                  return data || 0;
                }},
              { title: '重置金额', field: 'resetAmount'},
              { title: '创建者', field: 'creator'},
              { title: '创建时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '审批人', field: 'approvalUser'},
              { title: '审批时间', field: 'approvalTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              {title: window.$t('crs36.bt.operation'),width: 350,btnClick:[
                {name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit",hidden: (data, full) => {
                    return full.status > 1;
                  },auth:"crs36:experience:update"},
                {name:"删除",click:"delete",type:"primary",icon: "el-icon-delete",auth:"crs36:experience:delete"},
                {name: window.$t('crs36.active.copy'),click:"copy",type:"primary",icon:"el-icon-edit",auth:"crs36:experience:copy"},
                {name: "审批",click:"apply",type:"primary",icon:"el-icon-edit",hidden: (data, full) => {
                    return full.status > 1;
                  },confirm:true,br:true,auth:"crs36:experience:apply"},
                {name:"人工报名",click:"addUser",type:"primary",icon:"el-icon-edit",hidden: (data, full) => {
                    return full.status == 1 || full.status == 4;
                  },auth:"crs36:experience:addUser"},
                {name:"批量报名",click:"addUsers",type:"primary",icon:"el-icon-edit",hidden: (data, full) => {
                    return full.status == 1 || full.status == 4;
                  },auth:"crs36:experience:addUsers"},
              ]},
              ]
        }
      }
    }
  }
</script>
